import { render, staticRenderFns } from "./BlogCard.vue?vue&type=template&id=d9426642&scoped=true&"
import script from "./BlogCard.vue?vue&type=script&lang=js&"
export * from "./BlogCard.vue?vue&type=script&lang=js&"
import style0 from "./BlogCard.vue?vue&type=style&index=0&id=d9426642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9426642",
  null
  
)

export default component.exports